import { track } from '@amplitude/analytics-browser';
import { GlobalPagePropsContext } from '@contexts/GlobalPagePropsContext';
import { setCookieWckLiveAlarmValue } from '@wconcept/wconcept-common/utils/cookie';
import { addAsIsMWebDomain, currentUrl } from '@utils/domainUtil';
import { isNativeAppBoth } from '@utils/userAgentUtil';
import AgreeModal from '@wconcept/wconcept-ui/src/components/organisms/_modal/AgreeModal';
import NoticeModal from '@wconcept/wconcept-ui/src/components/organisms/_modal/NoticeModal';
import { useCallback, useContext, useEffect, useState } from 'react';
import { ModalsContext } from '@wconcept/wconcept-ui-renewal/src/contexts/ModalsContext';
import { requestConfirmShopLiveAlarmTalk } from '@apis/renewal/shoplive';
import useHistoryRouter from './useLinkTo';

const useAuthentication = () => {
  const { openModal, closeModal } = useContext(ModalsContext);
  const { appInfo, isMobile } = useContext(GlobalPagePropsContext);
  const { linkTo } = useHistoryRouter();

  const getIsGnbType = useCallback(() => {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get('gnbType') === 'Y';
  }, []);

  const onAuthenticationrNotice = useCallback(() => {
    if (appInfo?.isNativeAppBoth && getIsGnbType()) {
      document.location.href = 'wconceptkr://actionBarOff';
    }
    openModal(NoticeModal, {
      mode: 'mainBottom',
      type: !isMobile ? 'modal' : 'drawer',
      desktopMode: 'center',
      onClose: () => {
        if (appInfo?.isNativeAppBoth && getIsGnbType()) {
          document.location.href = 'wconceptkr://actionBarOn';
        }
      },
      onSubmit: async () => {
        if (appInfo?.isNativeAppBoth && getIsGnbType()) {
          document.location.href = 'wconceptkr://actionBarOn';
        }
        const targetUrl = `${await addAsIsMWebDomain(
          !isMobile ? '/MyPage/MemberInfo' : '/Member/SelfCertification'
        )}?reqFrom=ISSUE_LIVE&returnUrl=${encodeURIComponent(
          currentUrl({ isAddTimestamp: true })
        )}`;
        if (appInfo?.isNativeAppBoth && getIsGnbType() && isMobile) {
          document.location.href = `wconceptkr://newWebviewOpen?url=${encodeURIComponent(
            targetUrl
          )}`;
          return;
        }
        linkTo.push({
          url: targetUrl,
        });
      },
      value: {
        text: '본인인증이 필요합니다.<br/>마이페이지로 이동하여<br/>본인인증을 진행하시겠습니까?',
        submitText: '확인',
        isIPhoneXApp: appInfo.isIPhoneXApp, // 앱체크
        isDesktop: !isMobile,
        btnType: 'double',
        closeText: '취소',
      },
      className: 'notice-modal',
    });
  }, [appInfo, getIsGnbType, openModal, isMobile, linkTo]);

  const onMarketingInfo = useCallback(
    () =>
      new Promise((resolve, reject) => {
        if (appInfo?.isNativeAppBoth && getIsGnbType()) {
          document.location.href = 'wconceptkr://actionBarOff';
        }
        openModal(AgreeModal, {
          mode: 'mainBottom',
          desktopMode: 'center',
          onClose: () => {
            if (appInfo?.isNativeAppBoth && getIsGnbType()) {
              document.location.href = 'wconceptkr://actionBarOn';
            }
            resolve(false);
          },
          onSubmit: async () => {
            if (appInfo?.isNativeAppBoth && getIsGnbType()) {
              document.location.href = 'wconceptkr://actionBarOn';
            }
            await requestConfirmShopLiveAlarmTalk();
            setCookieWckLiveAlarmValue('Y');
            resolve(true);
          },
          value: {
            isDesktop: !isMobile,
            isIPhoneXApp: appInfo.isIPhoneXApp,
          },
        });
      }),
    [appInfo, getIsGnbType, isMobile, openModal]
  );

  return {
    onAuthenticationrNotice,
    onMarketingInfo,
  };
};

export default useAuthentication;
